@if(currentView === views.Home) {
  <div class="container">
    <button (click)="selectView(views.IpKeys, true)" class="request-button">Ver IP Keys</button>

    <button (click)="selectView(views.SearchByIP, true)" class="request-button">Buscar IP Keys por IP</button>
  </div>

  <div class="container">
    <button (click)="selectView(views.CreatingIpKey, true)" class="request-button">Crear IP Key</button>

    <button (click)="selectView(views.DeletingIP, true)" class="request-button">Eliminar IP</button>
  </div>
}

  <!-- Vista de crear IpKey, eliminar IP o buscar IP Key por IP -->
@if(currentView === views.CreatingIpKey || currentView === views.DeletingIP || currentView === views.SearchByIP) {
  <div class="create-ipKey-container">
    <h4>{{currentView === views.DeletingIP ? 'Eliminar IP' : (currentView === views.SearchByIP ? 'Buscar IP Keys por IP' : 'Crear IP Key')}}</h4>

    <input type="text" [(ngModel)]="ipKeyOrIP" class="create-ipKey-input" [placeholder]="currentView === views.CreatingIpKey ? 'IP Key' : 'IP'">

    <div class="create-ipKey-buttons">
      <button class="button-colors" (click)="selectView(views.Home, true)">Volver</button>

      <button class="modify-button button-colors"
        (click)="currentView === views.CreatingIpKey ? createIPKey() : (currentView === views.SearchByIP ? getKeysFromIP() : deleteIP('*', [this.ipKeyOrIP]))"
        [disabled]="currentView !== views.SearchByIP && (!globalService.editing || (!ipKeyOrIP || ipKeyOrIP.length === 0 || ipKeyOrIP === ' '))">
        Confirmar
      </button>
    </div>
  </div>
}

@if(currentView === views.IpKeys) {
  <div class="search-container">
    <input type="text" class="search-input" [(ngModel)]="ipKeyToSearch" (ngModelChange)="onSearchChange()" placeholder="Buscar por nombre">
    <button class="back-button button button-colors" (click)="selectView(views.Home, true)">Volver</button>
  </div>

  <!-- Vista de IP Keys -->
  <div class="scroll-container">
    <div class="ipKeys-container">
      @for(ipKey of ipKeys; track ipKey) {
        <div class="ipKey" (click)="selectView(views.IpKeyDetail, true, ipKey)">
          <p>{{ipKey}}</p>
        </div>
      }
    </div>
  </div>
}

<!-- Vista de detalle de IP Key -->
@if(currentView === views.IpKeyDetail) {
  <div class="ipKey-detail-container">
    <h4 class="detail-title">Detalles IP Key</h4>

    <div class="input-container">
      <p>IP Key: </p>
      <input type="text" class="new-input" [(ngModel)]="newIPKey" placeholder="IP Key">

      <button (click)="renameIPKey()" class="detail-button button-colors" [disabled]="!globalService.editing">Renombrar</button>
    </div>

    <div class="input-container">
      <p>Añadir IP: </p>
      <textarea type="text" class="new-input textarea" [(ngModel)]="newIP" placeholder="IPs"></textarea>

      <button (click)="addIPToKey(false)" class="detail-button button-colors" [disabled]="!globalService.editing">Añadir</button>
    </div>

    <div class="add-ipKeys-container">
      <p>Añadir IP Key: </p>

      <div class="selects-container">
        <div class="add-ipKey-container">
          <select [(ngModel)]="ipKeyToAdd" name="add-ipKey" class="add-ipKey">
            @for(ipKey of getFilteredAllIpKeys(); track ipKey) {
              <option [value]="ipKey">{{ipKey}}</option>
            }
          </select>

          <button (click)="addIPToKey(true)" class="add-ipKey-button button-colors" [disabled]="!globalService.editing">Añadir</button>
        </div>
      </div>
    </div>

    <div class="delete-ipKeys-container">
      <p>Eliminar IP Key/IP: </p>

      <div class="selects-container">
        <div class="delete-ipKey-container">
          <input type="text" class="delete-ip-input" [(ngModel)]="ipKeyOrIpToRemoveText" placeholder="IP Key (* para todas)">

          <button (click)="deleteIP(ipKeySelected, [ipKeyOrIpToRemoveText])" class="add-ipKey-button button-colors"
            [disabled]="!globalService.editing || (ipKeysOrIpToRemove && ipKeysOrIpToRemove.length === 0)">
            Eliminar
          </button>
        </div>

        <div class="delete-ipKey-container-2">
          <select [(ngModel)]="ipKeyOrIpToRemove" name="delete-ip" class="delete-ip">
            @for(ipKey of ipKeysOrIpToRemove; track ipKey) {
              <option [value]="ipKey">{{ipKey}}</option>
            }
          </select>

          <button (click)="deleteIP(ipKeySelected, [ipKeyOrIpToRemove])" class="add-ipKey-button button-colors"
            [disabled]="!globalService.editing || (ipKeysOrIpToRemove && ipKeysOrIpToRemove.length === 0)">
            Eliminar
          </button>
        </div>
      </div>
    </div>

    <div class="input-container">
      <p>Ver IPs: </p>
      <div class="show-ips-container">
        <label>
          Expandido
          <input class="checkbox" type="checkbox" [(ngModel)]="expand">
        </label>

        <button class="detail-button button-colors" (click)="getIPsFromKey()">Ver</button>
      </div>
    </div>

    <div class="edit-buttons">
      <button class="button button-colors" (click)="selectView(views.IpKeys, true)">Volver</button>

      @if(currentView === views.IpKeyDetail) {
        <button class="button button-colors" (click)="deleteIpKey()" [disabled]="!globalService.editing">Eliminar IP Key</button>
      }
    </div>
  </div>
}